import React, { Component } from 'react'
import RichText from '../Form/RichText'
import { withSettings } from '../withSettings'

@withSettings
export default class SubscriptionTemplate extends Component {
  componentDidMount() {
    this.props.registerDataHandler(data => this.props.setSettingsAt('email.subscription_template', data))
  }

  render() {
    const { subject, body } = this.props.getSettingsAt('email.subscription_template')
    const dynamicFields = this.props.getDynamicFieldsFor('subscriptions')

    return (
      <div>
        <div className="form-section">
          <p className="muted">
            Add text to the top of the saved listing and saved search emails sent to leads.
            <br/>
            <em>We highly recommend keeping this simple and very short.</em>
          </p>
        </div>
        <div className="form-section">
          <label>Subject</label>
          <RichText singleline name="subject" defaultValue={subject} dynamicFields={dynamicFields} />
        </div>

        <div className="form-section">
          <label>Message</label>
          <RichText name="body" defaultValue={body} dynamicFields={dynamicFields} />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/website/settings/Email/SubscriptionTemplate.js